import "../CampusDynamicSection/CampusDynamicSection.scss"
import { useState } from 'react';
import "../../CampusViewMore/CampusViewMore.scss"

const CampusDynamicSection = ({ data }) => {
    const [showContent, setShowContent] = useState(false)
  return (
   <>
               <div className='campus-dynamic-img-container'>
                   <img src={data.img} alt=""></img>
               </div>
               <div className='campus-dynamic-content'>
                   {
                    data.content && (
                        <p>{data.content}</p>  

                    )
                   }
                    {
                        data.workshoptitle && (
                            <h2>{data.workshoptitle}</h2>
                        )
                    } 
               </div>

               {
                data.workshopimg && (
                    <div className='campus-workshop-img-container'>
                   <img src={data.workshopimg} alt="workshop"></img>
               </div>
                )
               }
                {
                data.listHeading && (
                    <ul className='campus-lab-list-container'>
                        {
                            data.listHeading.map((headingItem,headingIndex) =>(
                                <li key={headingIndex}>{headingItem}
                                {
                                    data.listItems.map((listitems,listindex) => (
                                        <span>{listitems}</span>
                                    ))
                                }
                                </li>
                            )
                            
                            )
                        }

                    </ul>
                )
               }
               

   </>
  )
}

export default CampusDynamicSection